<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório quantitativo de produção">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/bpa/relatorio-quantitativo-producao/List'

export default {
    components: { List },
}
</script>